/**
 * BookmarkStar - 관심공고(즐겨찾기) 별표 토글
 *
 * 카드 좌측에 배치. 비활성 = 빈 별(회색), 활성 = 채워진 별(파랑).
 * 클릭 시 즉시 토글 (인스타/즐겨찾기식 인터랙션).
 */

import { Star } from "@semo/icons";
import { cn } from "@semo/shared-ui";

export interface BookmarkStarProps {
  active: boolean;
  onToggle: () => void;
  /** 접근성 라벨용 공고명 */
  label?: string;
  className?: string;
}

export function BookmarkStar({
  active,
  onToggle,
  label,
  className,
}: BookmarkStarProps) {
  return (
    <button
      type="button"
      aria-pressed={active}
      aria-label={
        active
          ? `${label ?? "공고"} 관심공고 해제`
          : `${label ?? "공고"} 관심공고 추가`
      }
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={cn(
        "flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-xl transition-all",
        "hover:bg-primary/10 active:scale-90",
        active ? "text-primary" : "text-slate-300 hover:text-primary/60",
        className,
      )}
    >
      <Star
        className={cn(
          "w-5 h-5 transition-all",
          active ? "fill-primary" : "fill-transparent",
        )}
        strokeWidth={active ? 2 : 1.8}
      />
    </button>
  );
}
